import {SerializedPixpenState} from '../history/serialized-pixpen-state';

export async function fetchStateJsonFromUrl(
  url: string
): Promise<SerializedPixpenState> {
  const response = await fetch(url);
  return response.json();
}
